export default "__VITE_ASSET__CP92kg6M__"